import * as React from 'react';
import { SVGProps } from 'react';

const SubmissionText = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.309 7.058h3.68v3.68"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.994 7.053 4.466 13.58a1.174 1.174 0 0 1-1.659 0A6.172 6.172 0 0 1 1 9.23c0-1.067.206-2.134.617-3.138a8.237 8.237 0 0 1 1.808-2.715 7.928 7.928 0 0 1 5.623-2.33c2.195 0 4.184.89 5.623 2.33A7.926 7.926 0 0 1 17 9c0 2.196-.89 4.184-2.33 5.623a7.926 7.926 0 0 1-5.622 2.33c-.857 0-1.711-.148-2.53-.424"
    />
  </svg>
);
export default SubmissionText;
